import styled from "styled-components"

export default function OrderDetailSection({ children }) {
  return <Section>{children}</Section>
}

const Section = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  padding-bottom: calc(100vw * (71 / 375));
`
